module.exports = __webpack_public_path__ + "static/home-girl@large-0eca01b2f0ba8e10fac109c231f5842b.jpg";